const usdaRouter = {
  route: null,
  name: null,
  title: '美国健康证',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-jiemiansheji',
  isElementIcon: false,
  filePath: 'view/usda/', // 文件路径
  order: null,
  inNav: true,
  children: [
    // 芯片号管理
    {
      title: '健康证管理',
      type: 'view',
      name: Symbol('center'),
      route: '/usda/hc/index',
      filePath: 'view/usda/hc/index.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      permission: ['芯片号管理'],
    },
    // 堪萨斯芯片爬虫
    {
      title: '爬虫管理',
      type: 'view',
      name: Symbol('center'),
      route: '/usda/spider/index',
      filePath: 'view/usda/spider/index.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      permission: ['爬虫管理'],
    },
  ],
}

export default usdaRouter
